import { EmailAddressField } from '@/components/shared/forms/WalletCommonFormFields'

export const PasswordRecoveryFormSchema = {
  fields: [EmailAddressField]
}
